import { jsx } from "panel";
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from "common/components/text-highlight";
import { TooltipItemType } from "./types";
function ChartTooltipItem({ item, key }) {
  if (item.type === TooltipItemType.Data) {
    return /* @__PURE__ */ jsx(TextHighlightEl, {
      sel: ".item",
      key,
      attrs: {
        theme: item.theme ? item.theme : TEXT_HIGHLIGHT_THEME.NEUTRAL,
        text: item.text
      }
    });
  }
  return /* @__PURE__ */ jsx("span", {
    sel: ".item",
    key,
    class: {
      [`section-${item.type}`]: true
    }
  }, item.text);
}
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".body"
  }, this.attr(`title-color`) ? /* @__PURE__ */ jsx("div", {
    sel: ".color-indicator",
    style: { "background-color": this.attr(`title-color`) },
    attrs: { elref: `titleColorIndicator` }
  }) : null, /* @__PURE__ */ jsx("div", {
    sel: ".sections",
    attrs: { elref: `sections` }
  }, this.attr(`sections`).map((section, sectionIdx) => {
    var _a;
    return /* @__PURE__ */ jsx("div", {
      sel: ".section-container",
      key: sectionIdx
    }, section.bulletColor ? /* @__PURE__ */ jsx("div", {
      sel: ".section-color-indicator",
      style: this.getItemBackground(section)
    }) : null, /* @__PURE__ */ jsx("div", {
      sel: ".section-rows-container"
    }, (_a = section.rows) == null ? void 0 : _a.map((row, rowIdx) => /* @__PURE__ */ jsx("div", {
      sel: ".section-row-container",
      key: rowIdx
    }, row.items.map((item, itemIdx) => /* @__PURE__ */ jsx(ChartTooltipItem, {
      item,
      key: itemIdx
    }))))));
  })), /* @__PURE__ */ jsx("slot", null)), this.attr(`footer-text`) ? /* @__PURE__ */ jsx("div", {
    sel: ".footer",
    attrs: { elref: `footer` }
  }, /* @__PURE__ */ jsx("span", null, this.attr(`footer-text`))) : null);
}
